// Initialize and add the map
function initMap() {
    const position = { lat: 60.37219937953463, lng: 25.09926588920525 };
    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 11,
        center: position,
    });
    // The marker, positioned at Uluru
    const marker = new google.maps.Marker({
        position: position,
        map: map,
    });
}

window.initMap = initMap;


window.addEventListener("load", () => {
    if (!document.getElementById("map")) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDVkgtCKxbIBuYwhbVswaf8yjSSja0gXyQ&callback=initMap&v=weekly";
    script.defer = true;
    const head = document.querySelector("head");
    if (!head) return;
    head.append(script);
});

